var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExclaimBubble = function SvgExclaimBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17C0 7.204 9.457 0 20.333 0 31.21 0 40.667 7.204 40.667 17v.048a15.693 15.693 0 0 1-4.236 10.349l.89 7.707a2 2 0 0 1-2.741 2.082l-9.215-3.748c-1.651.406-3.35.595-5.052.562C9.446 33.991 0 26.79 0 17ZM20.333 4C10.876 4 4 10.129 4 17s6.876 13 16.333 13h.041c1.547.032 3.09-.167 4.579-.59a2 2 0 0 1 1.3.07l6.706 2.729-.613-5.313a2 2 0 0 1 .62-1.69 11.691 11.691 0 0 0 3.7-8.23C36.652 10.115 29.78 4 20.334 4Zm0 2.667a2 2 0 0 1 2 2v10a2 2 0 0 1-4 0v-10a2 2 0 0 1 2-2ZM22 25.333a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z",
    fill: "#5C7783"
  })));
};
export default SvgExclaimBubble;